import Footer from '@alltrails/shared/components/Footer';
import { Context } from '@alltrails/shared/types/context';
import CustomProvider from '../CustomProvider';

type FooterWrapperProps = {
  context: Context;
  wideFooter: boolean;
};

const FooterWrapper = ({ context, wideFooter }: FooterWrapperProps): JSX.Element => {
  return (
    <CustomProvider>
      <Footer context={context} wideFooter={wideFooter} />
    </CustomProvider>
  );
};

export default FooterWrapper;
